(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular2-modal"), require("@angular/core"), require("@angular/common"));
	else if(typeof define === 'function' && define.amd)
		define(["angular2-modal", "@angular/core", "@angular/common"], factory);
	else if(typeof exports === 'object')
		exports["angular2Modal.vex"] = factory(require("angular2-modal"), require("@angular/core"), require("@angular/common"));
	else
		root["angular2Modal.vex"] = factory(root["angular2-modal"], root["@angular/core"], root["@angular/common"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_36__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition